<template>
  <div class="navi-tirgger-wrap">
    <i class="navi-tirgger" @click="toggle">
      <svg viewBox="0 0 40 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 24H40" />
        <path d="M0 13H40" />
        <path d="M0 2H40" />
      </svg>
    </i>
  </div>

  <div class="navi-wrap" :class="{ 'is-hide': !is_open }">
    <div class="inner">
      <div class="search-form">
        <i><svg-icon name="search" /></i>
        <input type="text" v-model="keyword" @keydown.enter="search" />
        <span @click="search">
          <svg-icon name="enter" />
        </span>
      </div>
      <ul>
        <li v-for="item in navi" :key="item.ID">
          <ui-link :post_link="item.url" v-html="item.title"></ui-link>
        </li>
      </ul>
    </div>
  </div>
  <div class="navi-bg" @click="close"></div>
</template>

<script>
export default {
  name: 'Navi',

  data() {
    return {
      navi: [],
      news: [],
      feeds: [],
      is_open: false,
      is_open_search: false,
      keyword: '',
    };
  },

  watch: {
    '$route.params': {
      handler() {
        this.is_open = false;
        this.is_open_search = this.$route.name === 'search';
        this.keyword = this.$route.query.key_word;
      },
      immediate: true,
    },
  },

  methods: {
    search() {
      // console.log("search", this.keyword);
      if (this.keyword && this.keyword !== '') {
        this.$router.push({
          path: '/search/',
          query: {
            key_word: this.keyword,
          },
        });
      }
    },

    openSearch() {
      if (this.is_open_search) {
        this.search();
      } else {
        this.is_open_search = true;
      }
    },

    toggle() {
      if (this.is_open) {
        this.close();
      } else {
        this.open();
      }
    },

    open() {
      this.is_open = true;
      document.documentElement.classList.add('disabled-scroll');
      document.body.classList.add('open-navi');
      // setTimeout(() => {
      //     document.documentElement.classList.add('disabled-scroll');
      //     document.body.classList.add('open-navi');
      // }, 10);
    },

    close() {
      document.body.classList.remove('open-navi');
      document.documentElement.classList.remove('disabled-scroll');
      this.is_open = false;
      // setTimeout(() => {
      //     document.documentElement.classList.remove('disabled-scroll');
      //     this.is_open = false;
      // }, 530);
    },

    toggle() {
      if (this.is_open) {
        this.close();
      } else {
        this.open();
      }
    },
  },

  mounted() {
    this.EventBus.on('toggle-navi', () => {
      this.toggle();

      // if (this.is_open) {
      //     this.close();
      // } else {
      //     this.open();
      // }
    });

    // window.addEventListener('keydown', (event) => {
    //     console.log('keydown', event)
    // });

    // window.addEventListener('keydown', this.keyEvent);

    this.$ajax.get('/menus/10').then((res) => {
      this.navi = res.data.items;
    });
  },
};
</script>

<style lang="scss">
.open-navi {
  .navi-bg {
    opacity: 0.35;
    pointer-events: all;
  }

  .navi-wrap {
    transform: translateY(0);

    @media screen and (max-width: 780px) {
      height: 100vh;
    }
  }
}

[aria-current]:not([aria-current='false']):not(.logo a) {
  color: var(--yellow);
}

.navi-bg {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 998;
  width: 100%;
  height: 100%;
  background-color: var(--yellow);
  pointer-events: none;
  opacity: 0;
  transition: 0.5s all ease-in-out;
}

.navi-wrap {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  background-color: var(--blue);
  transition: 0.5s all ease-in-out;
  height: 19rem;
  transform: translateY(-11.8rem);

  & > * {
    opacity: 0;
    pointer-events: none;
    transition: 0.3s all ease-in-out;

    @at-root {
      .open-navi & {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }

  // box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);

  @media screen and (max-width: 780px) {
    height: 100vh;
    transform: translateY(calc(-100vh + 8rem));
  }

  ul {
    display: flex;
    padding: var(--padding-x3) var(--padding-x2) var(--padding-x3);

    @media screen and (max-width: 780px) {
      padding: var(--padding) var(--padding-x2) var(--padding-x2);
      flex-wrap: wrap;
    }

    li {
      width: 20%;
      text-align: center;

      a {
        display: block;
        text-transform: uppercase;
        font-size: var(--medium-size);
        transition: 0.3s all ease;

        &:hover {
          color: var(--yellow);
        }
      }

      @media screen and (max-width: 780px) {
        width: 100%;
        padding-top: var(--padding-x2);
        a {
          font-size: var(--title-size);
        }
      }
    }
  }

  .search-form {
    margin: var(--padding-x2) 12rem var(--padding);
    position: relative;

    input {
      width: 100%;
      padding: 1.5rem 3.2rem 1.2rem 3.2rem;
      box-sizing: border-box;
      background-color: transparent;
      border: none;
      font-size: var(--medium-size);
      border-bottom: 1.5px solid var(--font-color);

      @media screen and (max-width: 780px) {
        border-bottom: 1px solid var(--font-color);
      }
    }

    i {
      height: 1.8rem;
      width: 1.8rem;
      position: absolute;
      bottom: 1.2rem;

      svg {
        height: 100%;
        width: 100%;
        display: block;
        stroke: var(--red);
      }
    }

    span {
      height: 3.2rem;
      width: 3.2rem;
      position: absolute;
      bottom: 1rem;
      right: 0;
      border: 1.5px solid var(--font-color);
      cursor: pointer;
      transition: 0.3s all ease;

      &:hover {
        background: #e8ffed;
      }

      svg {
        height: 100%;
        width: 100%;
        display: block;
      }

      @media screen and (max-width: 780px) {
        border-bottom: 1px solid var(--font-color);
      }
    }

    @media screen and (max-width: 780px) {
      margin: var(--padding-x2) var(--padding-x2) 0;

      input {
        padding: 2rem 4rem 1rem 4rem;
      }

      i {
        height: 3rem;
        width: 3rem;
        bottom: 1.2rem;
      }

      span {
        height: 4rem;
        width: 4rem;
        bottom: 1rem;
      }
    }
  }
}

@media screen and (min-width: 780px) {
  .navi-tirgger-wrap {
    position: fixed;
    max-width: var(--max-width);
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    pointer-events: none;
    top: 5.9rem;
    height: 2.6rem;
    transition: all 0.3s ease;

    .navi-tirgger {
      position: absolute;
    }
  }

  .mini + .header-bg + .navi-tirgger-wrap {
    top: 2.38rem;
  }
  
}

.navi-tirgger {
  height: 2.6rem;
  width: 2.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  right: var(--padding-x3);
  top: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  pointer-events: auto;

  svg {
    height: 100%;
    width: 100%;
    display: block;

    path {
      transition: 0.3s all ease-in-out;
      stroke-width: 4;
      stroke: var(--red);
      // stroke-linecap: round;

      // &:nth-child(3) {
      //     stroke: var(--blue);
      // }

      // &:nth-child(2) {
      //     stroke: var(--yellow);
      // }

      // &:nth-child(1) {
      //     stroke: var(--red);
      // }

      @at-root {
        .open-navi & {
          &:nth-child(3) {
            transform: translate(19%, -12%) rotate(45deg);
          }

          &:nth-child(2) {
            opacity: 0;
          }

          &:nth-child(1) {
            transform: translate(-27%, 35%) rotate(-45deg);
          }
        }
      }
    }
  }

  &:hover {
    svg {
      path {
        stroke: var(--yellow);
        // &:nth-child(3) {
        //     stroke: var(--yellow);
        // }

        // &:nth-child(2) {
        //     stroke: var(--red);
        // }

        // &:nth-child(1) {
        //     stroke: var(--blue);
        // }
      }
    }
  }

  @media screen and (max-width: 780px) {
    height: 3.2rem;
    width: 3.2rem;
    top: 2.2rem;
    right: var(--padding);
  }
}
</style>
